// @ts-nocheck
import { HtmlClassSwitch } from "./Dom";
import { SynchronizationState } from "./WebApp.Entity.Store";
import { application } from "./WebApp.Instance";
import { ApplicationMode } from "./WebApp.Store";
import { ClickOutsideListener } from "./WebSite.Page.Component";

export class SynchronizationCenter {
  constructor() {
    this.interactive = false;

    this.initialize();
  }

  connect(serviceWorker) {
    if (this.listener !== undefined)
      this.serviceWorker.removeEventListener("message", this.listener);

    this.listener = (event) => {
      const data = event.data;

      if (event.data.class === "Entities")
        this.reloadAll(data.value);
    }

    this.serviceWorker = serviceWorker;
    this.serviceWorker.addEventListener("message", this.listener);
  }

  initialize() {
    const elements = document.getElementsByClassName("Synchronization");

    if (elements.length === 1) {
      this.interactive = true;

      this.element = elements[0];
      this.element.addEventListener("click", (event) => { this.openMenu() });

      this.menuOpen = new HtmlClassSwitch(this.element, "Open");

      this.menu = document.createElement("div");
      this.menu.classList.add("SynchronizationMenu");

      this.element.appendChild(this.menu);

      this.button = document.createElement("button");
      this.button.addEventListener(
        "click",
        (event) => {
          this.setApplicationStatus(true);

          if (this.serviceWorker)
            this.serviceWorker.controller.postMessage({ Action: "StartSynchronization" });
        }
      );

      this.menu.appendChild(this.button);
      this.menu.appendChild(this.buildWebAppToggle());

      this.offline = new HtmlClassSwitch(this.element, "Offline");
      this.synchronizing = new HtmlClassSwitch(this.element, "Synchronizing");
      this.failures = new HtmlClassSwitch(this.element, "Failed");

      this.progress = document.createElement("progress");
      this.progress.max = 1;

      this.element.appendChild(this.progress);

      this.count = document.createElement("span");
      this.count.className = "Count";
      this.count.textContent = "";

      this.element.appendChild(this.count);
      this.reload();
    }
  }

  openMenu() {
    this.menuOpen.setStatus(true);
    this.clickOutsideListener = new ClickOutsideListener([this.menu], () => { this.closeMenu(); });
  }

  closeMenu() {
    this.menuOpen.setStatus(false);
    this.clickOutsideListener.remove();
  }

  buildWebAppToggle() {
    const toggle = document.createElement("div");

    this.webAppClassSwitch = new HtmlClassSwitch(toggle, "App");
    this.webAppClassSwitch.setStatus(application.mode === ApplicationMode.App);

    const icon = document.createElement("span");
    icon.classList.add("Icon");

    toggle.appendChild(icon);
    toggle.addEventListener("click", (event) => this.toggleApp());
    toggle.classList.add("Toggle");

    return toggle;
  }

  toggleApp() {
    if (application.mode === ApplicationMode.App)
      application.setMode(ApplicationMode.Web)
    else
      application.setMode(ApplicationMode.App);

    this.webAppClassSwitch.setStatus(application.mode === ApplicationMode.App);
  }

  async reload() {
    if (this.interactive) {
      const entities = await application.entityStore.getAll();
      this.updateCount(entities);
    }
  }

  updateCount(entities) {
    const values = entities ?? [];

    const pendingCount = values.filter(entity => this.isUnsynchronized(entity)).length;
    const failedCount = values.filter(entity => entity.State === SynchronizationState.Failed).length;

    this.count.textContent = pendingCount > 0 ? pendingCount : "";

    this.failures?.setStatus(failedCount > 0);
  }

  isUnsynchronized(entity) {
    return entity.State === SynchronizationState.Modified
      || entity.State === SynchronizationState.Conflict
      || entity.State === SynchronizationState.Failed;
  }

  reloadAll(entities) {
    if (this.interactive) {
      this.progress.value = entities.progress;
      this.updateCount(entities.values);
    }

    this.setApplicationStatus(entities.status, entities.synchronizing);
  }

  setApplicationStatus(online, synchronizing) {
    application.online = online;

    if (this.interactive) {
      this.offline.setStatus(!online);
      this.synchronizing.setStatus(synchronizing);
    }
  }
}
